import React from 'react';
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  List,
  Row,
  Select,
  Typography,
  Upload,
} from 'antd';
import { TimePicker } from 'antd/es';
import { DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import FormHelper from 'helpers/FormHelper';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';
import FileList from '../../../../../../../components/fileList/index.';
import { Descriptions } from 'antd';

const pickerStyles = {
  width: '100%',
};

const { Option } = Select;

const InfoSection = ({
  shops,
  inactiveShops,
  titleTypes,
  docs,
  isEdit,
  handleDeleteFile,
  updateInProcess,
  isView,
}) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={4}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={10}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            disabled={isView}
            placeholder={t('Insegna')}
            {...Helpers.addSearchProps()}
          >
            <Option value={''}>{t('Insegna')}</Option>
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item label={t('Categoria richiesta')} name='type_event'>
          <Select disabled={isView} placeholder={t('Categoria richiesta')}>
            <Option value={''}>{t('Categoria richiesta')}</Option>
            {Object.keys(titleTypes).map((i) => (
              <Option key={i} value={i}>
                {titleTypes[i]}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col offset={4} span={6}>
        <Form.Item label={t('Data dal')} name='date_from'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={pickerStyles}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label={t('Orario dalle')} name='time_from'>
          <TimePicker disabled={isView} minuteStep={15} format={'HH:mm'} style={pickerStyles} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Data al')} name='date_to'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={pickerStyles}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label={t('Orario alle')} name='time_to'>
          <TimePicker minuteStep={15} disabled={isView} format={'HH:mm'} style={pickerStyles} />
        </Form.Item>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item label={t('Nome richiedente in store')} name='staff'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item
          label={t('Telefono richiedente in store')}
          name='staff_phone'
        >
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item label={t('Descrizione')} name='work_description'>
          <Input.TextArea
            disabled={isView}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      <Col offset={4} span={20}>
        <Form.Item name='external_personal_access'>
          <Checkbox disabled={isView}>
            {t('Accesso personale esterno')}
          </Checkbox>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Typography.Title disabled={isView} level={3}>
          {t('Allegato')}
        </Typography.Title>
      </Col>
      <Col span={10}>
        <Form.Item>
          <Form.Item
            name='docs'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
          >
            <Upload.Dragger
              disabled={isView}
              multiple
              name='docs'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
            <Descriptions.Item label={`${t('Formati accettati')}:`}>
              PDF WORD XLS XLSX PPTX
            </Descriptions.Item>
            <Descriptions.Item label={`${t('Dimensione massima')}:`}>
              20MB
            </Descriptions.Item>
          </Descriptions>
        </Form.Item>
      </Col>
      {isEdit && docs.length > 0 && (
        <Col offset={4} span={10}>
          <FileList
            hideDeleteBtn={isView}
            data={docs}
            loading={updateInProcess}
            onDelete={(item) => handleDeleteFile(item.id)}
          />
        </Col>
      )}
    </Row>
  );
};

export default React.memo(InfoSection);
